<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-item label="签名授权" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag
                type="list"
                v-decorator="['authFlag']"
                :trigger-change="true"
                dictCode="signature_status"
                placeholder="请选择签名授权"
              > {{ authFlag_dictText }}</j-dict-select-tag>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="签名时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-date placeholder="请选择签名时间" v-decorator="['authTime']" :trigger-change="true" style="width: 100%"/>
            </a-form-item>
          </a-col>

          <a-col :span="24">
            <a-form-item label="在校瞬间授权" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag
                type="list"
                v-decorator="['empower']"
                :trigger-change="true"
                dictCode="signature_status"
                placeholder="请选择在校瞬间授权"
              > {{ empower_dictText }}</j-dict-select-tag>
            </a-form-item>
          </a-col>

          <a-col :span="24">
            <a-form-item label="消息推送授权" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag
                type="list"
                v-decorator="['receive']"
                :trigger-change="true"
                dictCode="signature_status"
                placeholder="请选择消息推送授权"
              > {{ receive_dictText }}</j-dict-select-tag>
            </a-form-item>
          </a-col>

          <a-col :span="24">
            <a-form-item label="付费状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag
                type="list"
                v-decorator="['feeStatus']"
                :trigger-change="true"
                dictCode="fee_status"
                placeholder="请选择付费状态"
                @change="changeFeeState"
              > {{ feeStatus_dictText }}</j-dict-select-tag>
            </a-form-item>
          </a-col>

          <a-col :span="24">
            <a-form-item label="试用期限" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-date placeholder="请选择试用期限" v-model="model.limitTime" :trigger-change="true" style="width: 100%"/>
            </a-form-item>
          </a-col>

        </a-row>
      </a-form>
    </j-form-container>
  </a-spin>
</template>

<script>
  import { httpAction, getAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import JDate from '@/components/jeecg/JDate'
  import JImageUpload from '@/components/jeecg/JImageUpload'
  import JDictSelectTag from '@/components/dict/JDictSelectTag'
  import JSearchSelectTag from '@/components/dict/JSearchSelectTag'

  export default {
    name: 'SchoolUserInfoList',
    components: {
      JFormContainer,
      JDate,
      JImageUpload,
      JDictSelectTag,
      JSearchSelectTag
    },

    data() {
      return {
        form: this.$form.createForm(this),
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        },
        confirmLoading: false,
        validatorRules: {},
        url: {
          add: '/aigoes/schoolUserInfo/add',
          edit: '/aigoes/schoolUserInfo/edit',
          queryById: '/aigoes/schoolUserInfo/queryById'
        },
        selectValue: '',
        asyncSelectValue: '',
        dictOptions: [
          {
            text: '是',
            value: '1'
          },
          {
            text: '否',
            value: '0'
          }
        ]
      }
    },
    methods: {
      add() {
        this.edit({})
      },
      edit(record) {
        console.log(record)
        this.form.resetFields()
        this.model = Object.assign({}, record)
        this.visible = true
        this.$nextTick(() => {
          this.form.setFieldsValue(
            pick(
              this.model,
              'id',
              'authFlag',
              'authTime',
              'authSign',
              'empower',
              'receive',
              'tenantId',
              'limitTime',
              'feeStatus'
            )
          )
        })
      },
      submitForm() {
        const that = this
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true
            let httpurl = ''
            let method = ''
            console.log(this.model.id)
            if (!this.model.id) {
              httpurl += this.url.add
              method = 'post'
            } else {
              httpurl += this.url.edit
              method = 'put'
            }
            let formData = Object.assign(this.model, values)

            console.log('表单提交数据', formData)
            formData.schoolClass={}
            // return
            httpAction(httpurl, formData, method)
              .then(res => {
                if (res.success) {
                  that.$message.success(res.message)
                  that.$emit('ok')
                } else {
                  that.$message.warning(res.message)
                }
              })
              .finally(() => {
                that.confirmLoading = false
              })
          }
        })
      }
      ,changeFeeState(val){
        console.log(val)
        if (val==1){
          this.model.limitTime = "2099-12-31"
        }
      }
    }
  }
</script>
